import styled from "styled-components";
import { tokens } from "../../public/tokens";

export const StyledDestructiveBulkButton = styled.button({
    height: "35px",
    padding: `0 ${tokens.globals["spacing-4"]}`,
    border: `1px solid ${tokens.colors.ui.destructive}`,
    borderRadius: tokens.globals["border-radius"],
    background: tokens.colors.ui.destructive,
    color: tokens.colors.neutral.white,
    boxShadow: tokens.effects.effects.shadow.default,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: tokens.globals["spacing-1-5"],
    fontFamily: tokens.typography.fontFamilies["albert-sans"],
    fontSize: tokens.typography.fontSize["lg-14px"],
    fontWeight: tokens.typography.fontWeights.semibold,
    cursor: "pointer",
    whiteSpace: "nowrap",
    "&:disabled": {
        opacity: 0.5,
        cursor: "not-allowed",
    },
});
